<template>
  <teleport to="#modals">
    <div class="asModal" :class="modalClasses" v-if="modelValue">
      <div class="asModal_overlay" @click="onBackdropClose"></div>
      <div
        class="asModal_content"
        :class="`-${typeModal}`"
      >
        <div v-if="btnClose" class="asModal_close" @click="close">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_18923_5892)">
              <path d="M12.5007 10.586L16.7437 6.34299C17.1342 5.95252 17.7673 5.95252 18.1577 6.34299C18.5482 6.73345 18.5482 7.36652 18.1577 7.75699L13.9147 12L18.1577 16.243C18.5482 16.6335 18.5482 17.2665 18.1577 17.657C17.7673 18.0475 17.1342 18.0475 16.7437 17.657L12.5007 13.414L8.25772 17.657C7.86725 18.0475 7.23418 18.0475 6.84372 17.657C6.45325 17.2665 6.45325 16.6335 6.84372 16.243L11.0867 12L6.84372 7.75699C6.45325 7.36652 6.45325 6.73345 6.84372 6.34299C7.23418 5.95252 7.86725 5.95252 8.25772 6.34299L12.5007 10.586Z" fill="#203454"/>
            </g>
            <defs>
              <clipPath id="clip0_18923_5892">
                <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
              </clipPath>
            </defs>
          </svg>
        </div>

        <span class="asModal_title" v-if="title">
          {{ title }}
        </span>

        <div class="asModal_inner">
          <slot :close="close" />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, watch } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: [Boolean, String],
      default: () => false
    },
    btnClose: {
      type: Boolean,
      default: () => true
    },
    backdropClose: {
      type: Boolean,
      default: () => true
    },
    title: {
      type: String,
      default: () => null
    },
    typeModal: {
      type: String,
      default: 'default' // default, fullScreen, fullSize, picker, image, video, careServiceModal
    },
    modalClasses: {
      type: String,
      default: () => ''
    }
  },
  emits: ['update:modelValue'],
  setup (props, ctx) {
    onBeforeUnmount(() => {
      document.body.style.overflowY = ''
    })

    function close () {
      ctx.emit('update:modelValue', false)
    }

    function onBackdropClose () {
      if (props.backdropClose) {
        close()
      }
    }

    watch(() => props.modelValue, (val) => {
      document.body.style.overflowY = val ? 'hidden' : ''
    }, {
      immediate: true
    })

    return {
      close,
      onBackdropClose
    }
  }
})
</script>

<style lang="scss">
  .asModal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;

    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;

    &_overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      &::after {
        content: '';

        position: absolute;
        top: -2px;
        left: -2px;

        height: calc(100% + 4px);
        width: calc(100% + 4px);
        backdrop-filter: blur(5px);
      }
    }

    &_close {
      position: absolute;
      top: 0;
      right: 0;
      width: 60px;
      height: 60px;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    &_title {
      display: block;
      margin-bottom: 19px;

      color: #4c5264;
      font-size: 16px;
      line-height: 20px;
      padding: 20px 25px 0;
    }

    &_content {
      position: relative;
      max-width: 344px;
      width: 100%;
      height: auto;

      box-shadow: 0 0 35px rgba(0, 0, 0, 0.16);
      border-radius: 10px;
      background-color: #ffffff;

      overflow: auto;

      &.-image,
      &.-video {
        max-width: 100%;
        width: auto;
        max-height: 100%;
        height: auto;
        background-color: transparent;
        box-shadow: none;
        margin: 0 auto;
        z-index: 1;
      }

      &.-video {
        background: white;
      }

      &.-fullSize {
        max-width: 90%;
        width: 100%;
        max-height: 90%;
        height: 100%;
      }

      &.-picker {
        border-radius: 0;
        background-color: transparent;
      }

      &.-careServiceModal {
        max-width: 376px;

        @media (max-width: 768px) {
          max-width: 340px;
        }
      }

      &.-fullScreen {
        max-width: 100%;
        width: 100%;
        max-height: 100%;
        height: 100%;
        border-radius: 0;
      }
    }

    &_content.-image img,
    &_content.-video video {
      display: block;
      max-width: 90vw;
      max-height: 90vh;
      object-fit: contain;
    }

    &_inner {
      height: 100%;
      width: 100%;
    }
  }
</style>
